import axios from './apiClient';

function getMachines() {
    return axios.get('Machines');
}
function createMachine(machine) {
    return axios.post('Machines', machine);
}
function editMachine(machine) {
    return axios.put(`Machines/${machine.id}`, machine);
}
function deactivateMachine(machineId) {
    return axios.delete(`Machines/${machineId}`);
}
function reactivateMachine(machineId) {
    return axios.put(`Machines/${machineId}/Reactivate`);
}
function createTool(machineId, tool) {
    return axios.post(`Machines/${machineId}/Tools`, tool);
}
function editTool(machineId, tool) {
    return axios.put(`Machines/${machineId}/Tools/${tool.id}`, tool);
}
function deactivateTool(machineId, toolId) {
    return axios.delete(`Machines/${machineId}/Tools/${toolId}`);
}
function reactivateTool(machineId, toolId) {
    return axios.put(`Machines/${machineId}/Tools/${toolId}/Reactivate`);
}
export default {
    getMachines,
    createMachine,
    editMachine,
    deactivateMachine,
    reactivateMachine,
    createTool,
    editTool,
    deactivateTool,
    reactivateTool
};
